//Sample Note Class 
export class Note {
    id: number;
    notes: string;
    date: any; 
}
  


// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/quickview/note.ts